import script from "./contentFoots.vue?vue&type=script&setup=true&lang=js"
export * from "./contentFoots.vue?vue&type=script&setup=true&lang=js"

import "./contentFoots.vue?vue&type=style&index=0&id=720407d8&scoped=true&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-720407d8"]])

export default __exports__